<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableSearch">


          <el-form-item :label="$t('text.keywords')">
            <el-input
                style="width: 300px"
                v-model="form.message"
                :placeholder="$t('message.input')"
                maxlength="40"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.traceId')">
            <el-input
                style="width: 400px"
                :value="form.traceId"
                :placeholder="$t('message.input')"
                maxlength="60"
                @input="onTraceIdInput"
            ></el-input>
          </el-form-item>

        </template>
        <template slot="tableColumn">
          <el-table-column
              prop="logTime"
              width="180px"
              :label="$t('text.time')"
              align="center"/>


          <el-table-column
              prop="message"
              width="1100px"
              :label="$t('text.message')"
              header-align="center"
              align="left"
          >
            <template slot-scope="{ row }">
              <div v-if="row.message">
                <el-popover v-if="row.message.length > 100"
                            placement="top-start"
                            trigger="hover">
                  <pre>{{ row.message }}</pre>
                  <div slot="reference" class="remark">
                    {{ row.message }}
                  </div>
                </el-popover>

                <div v-else>
                  <pre>{{ row.message }}</pre>
                </div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>


          <el-table-column
              prop="traceId"
              width="400px"
              :label="$t('text.traceId')"
              header-align="center"
              align="left"
              style="padding-left: 10px"
          />
        </template>


      </page>
    </div>
  </div>
</template>
<script>

import Page from "@/components/Page.vue";
import loading from "element-ui/packages/loading";
import moment from "moment";


export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/elk-log/select",
      form: {
        traceId: "",
        message: "",
      },
    };
  },
  methods: {
    reset() {
      this.traceId = "";
      this.message = "";
    },
    onTraceIdInput(value) {
      this.form.traceId = value.trim();
    }
  },
  created() {
    this.reset();
  }
};
</script>

<style scoped>
.remark {
  white-space: pre-line;
}

.el-popover pre {
  max-width: 750px;
  max-height: 500px;
  overflow: auto;
  white-space: pre-wrap;
}
</style>